let ENGLISH = "en"
let JAPANESE = "jp"
let TRADITIONAL_CHINESE = "tc"
let SIMPLIFIED_CHINESE = "sc"

const LANGUAGE_ABBR = {
    ENGLISH: ENGLISH,
    JAPANESE: JAPANESE,
    TRADITIONAL_CHINESE: TRADITIONAL_CHINESE,
    SIMPLIFIED_CHINESE: SIMPLIFIED_CHINESE,
}

export const MovementCategoriesMapping = {
    1: {
        [ENGLISH]: "Small Skill",
        [JAPANESE]: "小技",
        [TRADITIONAL_CHINESE]: "小技",
        [SIMPLIFIED_CHINESE]: "小技",
    },
    2: {
        [ENGLISH]: "Torch",
        [JAPANESE]: "火把",
        [TRADITIONAL_CHINESE]: "火把",
        [SIMPLIFIED_CHINESE]: "火把",
    }
}